import { TGetContactDetailResDto } from "@/api/services/admin/contact/dtos/get-contact-detail.dto";
import { TGetContactListReqDto, TGetContactListResDto } from "@/api/services/admin/contact/dtos/get-contact-list.dto";
import { TUpdateContactIsResolvedResDto } from "@/api/services/admin/contact/dtos/update-contact.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export const fetchContactListApi = async (req: TGetContactListReqDto): Promise<TGetContactListResDto> => {
  const url = createUrlWithParams("/contacts", req);
  const { data } = await clientApi.get<TGetContactListResDto>(url);
  return data;
};

export const useContactList = (req: TGetContactListReqDto, enabled?: boolean) => {
  return useQuery({
    queryKey: [QUERY_KEYS.CONTACT.FETCH_LIST, req],
    queryFn: () => fetchContactListApi(req),
    enabled: enabled ?? true,
  });
};

export const fetchContactDetailApi = async (contactId: string): Promise<TGetContactDetailResDto> => {
  const rs = await clientApi.get<TGetContactDetailResDto>(`/contacts/${contactId}`);
  return rs.data;
};

export const useContact = () => {
  const { id } = useParams();

  return useQuery({
    queryKey: [QUERY_KEYS.CONTACT.FETCH_DETAIL, id],
    queryFn: () => (id ? fetchContactDetailApi(id) : undefined),
    enabled: Boolean(id),
  });
};

export const updateContactIsResolved = async (contactId: number): Promise<TUpdateContactIsResolvedResDto> => {
  const rs = await clientApi.put<TUpdateContactIsResolvedResDto>(`/contacts/${contactId}/is-resolved`);
  return rs.data;
};
